<template>
  <v-dialog
    v-model="dialogModel"
    max-width="400px"
  >
    <v-card>
      <v-card-title
        :class="`${color} white--text title font-weight-thin mb-4`"
      >
        {{ title }}
      </v-card-title>

      <v-card-text>
        <span v-html="description" />
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          rounded
          text
          :disabled="isLoading"
          @click="$emit('cancel')"
        >
          Cancel
        </v-btn>
        <v-btn
          outlined
          rounded
          :color="color"
          :loading="isLoading"
          @click="confirmed"
          @keyup.enter="confirmed"
        >
          {{ actionText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      model: {},
      color: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      actionText: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        dialogModel: false,
        isLoading: false
      }
    },
    watch: {
      'model': function() {
        this.dialogModel = !!this.model
        // If the model was closed, reset the loading
        if (this.dialogModel === false) {
          this.isLoading = false
          this.$emit('cancel')
        }
      },
      'dialogModel': function() {
        if (this.dialogModel === false) {
          this.isLoading = false
          this.$emit('cancel')
        }
      }
    },
    methods: {
      confirmed() {
        this.isLoading = true
        this.$emit('confirmed')
      }
    }
  }
</script>
